import { render, staticRenderFns } from "./RangeDetails.vue?vue&type=template&id=360da69f&scoped=true"
import script from "./RangeDetails.vue?vue&type=script&lang=ts"
export * from "./RangeDetails.vue?vue&type=script&lang=ts"
import style0 from "./RangeDetails.vue?vue&type=style&index=0&id=360da69f&lang=scss"
import style1 from "./RangeDetails.vue?vue&type=style&index=1&id=360da69f&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "360da69f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sandeep/Work/EIOSYS/Cona-OSUM/Cona-Electrical-Admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('360da69f')) {
      api.createRecord('360da69f', component.options)
    } else {
      api.reload('360da69f', component.options)
    }
    module.hot.accept("./RangeDetails.vue?vue&type=template&id=360da69f&scoped=true", function () {
      api.rerender('360da69f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ranges/components/RangeDetails.vue"
export default component.exports